<script setup>
import {ref, watch} from "vue";
import marketsService from "@/services/markets.service";

const updates = ref([]);
const props = defineProps(['searchType','searchObjectId']);

watch(props, () => {
    getData();
}, {immediate: true, deep: true});

async function getData() {
    updates.value = [];
    const {data} = await marketsService.getUpdates(props);

    updates.value = data;
}
</script>

<template>
    <div class="card-markets__content">
        <div class="updates-content">
            <div
                v-for="(item, index) in updates"
                :key="index"
                class="activity-item activity-item__partnership"
            >
                <div class="activity-item-header">
                    <div class="activity-item__data">
                        <h6 class="heading6">New Partnership</h6>
                    </div>

                    <time class="activity-item__time">{{item.time}}</time>
                </div>

                <p v-html="item.summary"/>
            </div>
        </div>

<!--        <div class="activity-item activity-item__branching">-->
<!--            <div class="activity-item-header">-->
<!--                <div class="activity-item__data">-->
<!--                    <h6 class="heading6">Branching Out</h6>-->
<!--                </div>-->

<!--                <time class="activity-item__time">14h ago</time>-->
<!--            </div>-->

<!--            <p><a href="#">IBM</a> added new partnerships in <a href="#">Robotics &amp; Automation</a> for the first time.</p>-->
<!--        </div>-->

<!--        <div class="activity-item activity-item__trend">-->
<!--            <div class="activity-item-header">-->
<!--                <div class="activity-item__data">-->
<!--                    <h6 class="heading6">Trend Watch</h6>-->
<!--                </div>-->

<!--                <time class="activity-item__time">14h ago</time>-->
<!--            </div>-->

<!--            <p>The <a href="#">Computer Vision</a> space is growing quickly, with 6 new partnerships in the last week</p>-->
<!--        </div>-->
    </div>
</template>

<style scoped>

</style>
